import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { HardHat, Menu, X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/compare', label: 'Compare' },
  { to: '/team', label: 'For Admins' }
];

export default function Navbar() {
  const { user, signOut } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-[#0a0a0c]/80 border-b border-[#1a1a20]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group">
          <div className="w-8 h-8 rounded-lg bg-[#ea9a6f] flex items-center justify-center group-hover:rotate-6 transition-transform">
            <HardHat className="w-4 h-4 text-[#0a0a0c]" strokeWidth={2.5} />
          </div>
          <span className="serif text-2xl text-white">Crew<span className="text-[#ea9a6f]">Face</span></span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((l) => {
            const active = location.pathname === l.to || (l.to === '/compare' && location.pathname.startsWith('/compare'));
            return (
              <Link key={l.to} to={l.to} className={`px-3 py-2 text-sm rounded-md transition-colors ${active ? 'text-white' : 'text-[#9a978f] hover:text-white'}`}>
                {l.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          {user ? (
            <>
              <Link to="/app" className="text-sm text-[#c9c6bf] hover:text-white px-3 py-2">Dashboard</Link>
              <Button onClick={() => { signOut(); navigate('/'); }} variant="ghost" className="text-[#c9c6bf] hover:text-white hover:bg-[#1a1a20]">Sign out</Button>
            </>
          ) : (
            <>
              <Link to="/sign-in" className="text-sm text-[#c9c6bf] hover:text-white px-3 py-2">Sign in</Link>
              <Link to="/sign-up">
                <Button className="bg-[#ea9a6f] hover:bg-[#e0895a] text-[#0a0a0c] font-medium rounded-full px-5">Create free account</Button>
              </Link>
            </>
          )}
        </div>

        <button className="md:hidden text-white p-2" onClick={() => setOpen(!open)}>
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#1a1a20] bg-[#0a0a0c] px-5 py-4 flex flex-col gap-2">
          {navLinks.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-[#c9c6bf] py-2">{l.label}</Link>
          ))}
          {user ? (
            <>
              <Link to="/app" onClick={() => setOpen(false)} className="text-white py-2">Dashboard</Link>
              <button onClick={() => { signOut(); setOpen(false); navigate('/'); }} className="text-left text-[#c9c6bf] py-2">Sign out</button>
            </>
          ) : (
            <>
              <Link to="/sign-in" onClick={() => setOpen(false)} className="text-[#c9c6bf] py-2">Sign in</Link>
              <Link to="/sign-up" onClick={() => setOpen(false)}>
                <Button className="w-full bg-[#ea9a6f] hover:bg-[#e0895a] text-[#0a0a0c] rounded-full">Create free account</Button>
              </Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
